"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Clipboard;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Clipboard(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "clipboard"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-2",
    "data-name": "outline",
    d: "M81,25.24l-7.81-7.81L65.73,9.65a5.79,5.79,0,0,0-4.16-1.78H38a5.78,5.78,0,0,0-5.76,5.77v9.17H23.09a5.77,5.77,0,0,0-5.76,5.76V84.28a5.6,5.6,0,0,0,5.59,5.59H62a5.77,5.77,0,0,0,5.76-5.76V74.94h9.17a5.77,5.77,0,0,0,5.76-5.76V29.31A5.72,5.72,0,0,0,81,25.24ZM65.89,16l4.21,4.41,4.29,4.28H66.18a1.76,1.76,0,0,1-.29-.21ZM63.43,84.11A1.45,1.45,0,0,1,62,85.57H22.92a1.29,1.29,0,0,1-1.29-1.29V28.57a1.45,1.45,0,0,1,1.46-1.45H46.63a1.73,1.73,0,0,1,.32,0V39.61A4.6,4.6,0,0,0,51,43.67H63.31a1.43,1.43,0,0,1,.12.58ZM51,39.36V31l4.22,4.4,4.28,4.29H51.27A1.88,1.88,0,0,1,51,39.36ZM78.37,69.18a1.45,1.45,0,0,1-1.46,1.45H67.74V44.25a5.71,5.71,0,0,0-1.69-4.07l-7.81-7.81-7.45-7.78a5.77,5.77,0,0,0-4.16-1.78H36.57V13.64A1.45,1.45,0,0,1,38,12.18H61.57a1.17,1.17,0,0,1,.32,0v13c0,1.64,2.46,3.53,4.07,3.53H78.25a1.43,1.43,0,0,1,.12.58Z"
  }))));
}